import UserToAdd from "./add-user"
import CompanyUser from "../../../model2/company-user-new/company-user"
import ProjectSession from "../../../model2/project/project-session"
import {ProjectAccess} from "../../../gd/const/project"

// Same pools as the legacy meeting modal: project users with LIMITED+ access,
// then non-client company users who are not in the project at all

function toSortedUsersToAdd(companyUsers: (CompanyUser | undefined)[]): UserToAdd[] {
    const usersToAdd = _.map(_.compact(companyUsers), (companyUser: CompanyUser) => {
        return new UserToAdd(companyUser)
    })

    return _.sortBy(usersToAdd, (userToAdd: UserToAdd) => {
        return userToAdd.user.name
    })
}

export function meetingProjectUsersToAdd(project?: ProjectSession): UserToAdd[] {
    const userIds = project ? project.userIds(ProjectAccess.LIMITED) : []

    return toSortedUsersToAdd(_.map(userIds, (userId: ID) => {
        return gd.session.companyUsers.getByUserId(userId)
    }))
}

export function meetingCompanyUsersToAdd(project?: ProjectSession): UserToAdd[] {
    const projectUserIds = project ? project.userIds() : []

    return toSortedUsersToAdd(_.reject(gd.session.companyUsers.notClients(), (companyUser: CompanyUser) => {
        return projectUserIds.includes(companyUser.userId)
    }))
}
